import type { JSX } from 'preact';
import { cn } from '../lib/cn';

export function Input({
  class: cls,
  ...rest
}: JSX.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...rest}
      class={cn(
        'h-10 w-full rounded border border-surface-muted/40 bg-surface px-3 text-base',
        'focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/40',
        cls as string | undefined,
      )}
    />
  );
}
